<app-shell class="mat-body mat-typography">
  @if (erLoggetInd$ | async) {
    <eforsyning-sidenav-menu
      class="leftmenu narrow-scrollbar"
      role="navigation"
      aria-label="Secondary navigation"
    ></eforsyning-sidenav-menu>
  }
  <app-vaelg-installation
    class="vaelg-installation backgroundcolor2"
    [classList]="(erLoggetInd$ | async) ? '' : 'vaelg-installation--disabled'"
  ></app-vaelg-installation>
  <main class="content" id="main" role="main">
    <div class="container">
      @for (info of infos$ | async; track info) {
        @if (info.visible) {
          <app-info [value]="info" (close)="onCloseAppInfo($event)"></app-info>
        }
      }
      <router-outlet></router-outlet>
    </div>
  </main>
</app-shell>
